import { render, staticRenderFns } from "./VIconButton.vue?vue&type=template&id=3efd805c"
import script from "./VIconButton.vue?vue&type=script&lang=ts"
export * from "./VIconButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports